<div class="grow">
  <div class="flex flex-col def-version-header">
    <div class="max-width-lg bg-gradient pt-16">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
      <div class="flex flex-row justify-between">
        <div class="mb-20" class="flex flex-row justify-center items-center">
          <div class="mr-32">
            <mat-icon (click)="goBack()" class="icon cursor-pointer"
                      svgIcon="arrow_back"></mat-icon>
          </div>
          <div class="flex-row mb-10 mr-24">
            <div class="mat-headline-3 mb-0 mr-32">{{ blueprint?.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isDemoBlueprint" class="max-width-lg mt-30">
      <div class="flex flex-row items-center solution-card h-72 p-20">
        <div class="flex flex-row justify-center items-center sandbox">
          <img [alt]="'service-logo'" [src]="'/assets/icons/bank.svg'" class="w-34 h-36 mr-20">
          <div class="mat-subtitle-2 ml-16 mr-80 mb-0 word-break-word">{{ service?.name }}</div>
        </div>
        <div class="flex flex-row justify-center">
          <div class="mat-subtitle-2 fw-500 ml-16 mr-80 mb-0">{{blueprint?.name}}</div>
        </div>
        <div class="flex flex-row justify-center">
          <div class="mat-subtitle-2 fw-500 ml-16 mr-80 mb-0">
            {{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.CREATING_NEW_SERVICE_DEFINITION' | transloco}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isDemoBlueprint" class="max-width-lg mt-30">
      <div class="flex flex-row items-center solution-card h-72 p-20">
        <div class="flex flex-row justify-center items-center sandbox">
          <img [alt]="'sandbox-logo'" [src]="'/assets/images/sandbox.png'" class="w-34 h-36 mr-20">
          <div class="mat-subtitle-2 ml-16 mr-80 mb-0 word-break-word">{{ sandbox?.service?.name }}</div>
        </div>
        <div class="flex flex-row justify-center items-center">
          <div class="mat-subtitle-2 fw-500 ml-16 mr-80 mb-0">{{blueprint?.name}}</div>
        </div>
        <div class="flex flex-row justify-center items-center status w-25-percent">
          <ng-container
            *ngIf="DeployStatus.DEPLOYED === sandbox?.instance?.status && trialStatus.includes('expired'); else isNotExpired">
            <div *ngIf="sandbox?.instance?.status" class="warn-solid-bg traffic-light icon-container mr-16">
              <mat-icon class="flex items-center white-fg icon icon-sm" svgIcon="error_outline"></mat-icon>
            </div>
            <div class="mat-subtitle-2 fw-600">
              {{'SANDBOX.EXPIRED' | transloco}}
            </div>
          </ng-container>
          <ng-template #isNotExpired>
            <ng-container
              *ngIf="[DeployStatus.DEPLOYING, DeployStatus.TERMINATING, DeployStatus.UPDATING].includes(sandbox?.instance?.status); else showIconStatuses">
              <div *ngIf="instanceStatus" [ngClass]="statusInfo[sandbox?.instance?.status]?.colorClass"
                   class="traffic-light icon-container mr-20 accent-1-bg">
                <mat-icon class="flex items-center white-fg icon-sm" svgIcon="change_circle"></mat-icon>
              </div>
            </ng-container>
            <ng-template #showIconStatuses>
              <div *ngIf="instanceStatus" [ngClass]="statusInfo[sandbox?.instance?.status]?.colorClass"
                   class="traffic-light icon-container mr-20">
                <mat-icon [svgIcon]="statusInfo[sandbox?.instance?.status]?.icon" class="white-fg icon-sm"></mat-icon>
              </div>
            </ng-template>
            <div class="mat-subtitle-2 fw-600 mb-0 word-break-word">
              {{(sandbox?.instance?.status ? 'INSTANCE_STATUS.' + sandbox?.instance?.status : 'INSTANCE_STATUS.NA') | transloco}}
            </div>
          </ng-template>
        </div>
        <div class="mat-subtitle-2 fw-600 mb-0 word-break-word">
          {{trialStatus}}
        </div>
      </div>
    </div>
    <div *ngIf="capabilitiesGroups?.length > 0" class="max-width-lg capabilities-bg-gradient w-100-percent pt-14 pb-40">
      <ng-container *ngFor="let capabilitiesGroup of capabilitiesGroups">
        <mat-accordion *ngIf="capabilitiesGroup.name === CapabilityType.MANDATORY">
          <mat-expansion-panel class="remove-mat-expansion-panel-padding mb-8">
            <mat-expansion-panel-header #versionPanel
                                        (click)="!blueprintLatestVersion?.capabilities?.length ? versionPanel._toggle(): 'null'"
                                        class="h-72">
              <mat-panel-title class="mat-subtitle-2 fw-500 m-0">
                <div class="mat-headline-5 fw-700 mb-24 mt-28">
                  {{capabilitiesGroup.name === CapabilityType.MANDATORY ? ('CAPABILITIES.INCLUDED_CAPABILITIES' | transloco) :
                  ('CAPABILITIES.OPTIONAL_CAPABILITIES' | transloco)}}
                  {{capabilitiesGroup.capabilities ? '(' + capabilitiesGroup.capabilities.length + ')' : ''}}
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex flex-wrap ml--12 mr--12">
              <ng-container *ngFor="let capability of capabilitiesGroup.capabilities">
                <div class="pl-12 pr-12 mb-24 w-25-percent">
                  <app-capability-card (selectionChanged)="selectionChanged($event)"
                                       [capabilityDescription]="capabilityDescription" [capability]="capability"
                                       [isUpdated]="isUpdated(capability)"
                                       [selectable]="capability.required === CapabilityType.OPTIONAL"
                                       ></app-capability-card>
                </div>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-divider class="neutral-2"></mat-divider>
        <div *ngIf="capabilitiesGroup.name === CapabilityType.OPTIONAL" class="mat-headline-5 fw-700 mb-24 mt-28">
          {{'CAPABILITIES.OPTIONAL_CAPABILITIES' | transloco}} {{capabilitiesGroup.capabilities ? '(' + capabilitiesGroup.capabilities.length + ')' : ''}}
        </div>
        <div *ngIf="capabilitiesGroup.name === CapabilityType.OPTIONAL">
          <div class="flex flex-wrap ml--12 mr--12">
            <ng-container *ngFor="let capability of capabilitiesGroup.capabilities">
              <div class="pl-12 pr-12 mb-24 w-25-percent">
                <app-capability-card (selectionChanged)="selectionChanged($event)"
                                     [capabilityDescription]="capabilityDescription" [capability]="capability"
                                     [isUpdated]="isUpdated(capability)"
                                     [selectable]="capability.required === CapabilityType.OPTIONAL"
                                     ></app-capability-card>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <span class="flex-auto"></span>
    <div class="summary-header pale max-width-lg mt-auto">
      <div class="flex flex-row justify-center items-center">
        <mat-icon (click)="goBack()" class="icon-sm cursor-pointer mr-8" svgIcon="arrow_back"></mat-icon>
        <ng-container *ngFor="let capabilitiesGroup of capabilitiesGroups">
          <span  *ngIf="capabilitiesGroup.name === CapabilityType.MANDATORY" class="flex justify-items-center bubble fw-600 mr-6 pl-8 p-4 mat-body-1 m-0">
            {{capabilitiesGroup.capabilities ? (capabilitiesGroup.capabilities.length + additionalIncluded?.length) : 0}}
          </span>
        </ng-container>
        <span class="mat-body-1 m-0">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.INCLUDED' | transloco}}</span>
        <div class="copyright delimiter"></div>
        <span class="flex justify-items-center bubble fw-600 mr-6 pl-8 p-4 mat-body-1 m-0">{{selectedCapabilitiesArr?.length + createdCapabilities?.length}}</span>
        <span class="mat-body-1 m-0">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.OPTIONAL' | transloco}}</span>
        <mat-icon (click)="resetSelection()" svgIcon="refresh" class="icon-md cursor-pointer ml-8"></mat-icon>
        <button (click)="goBack()" class="flex justify-items-center items-center cancel-btn ml-auto mr-26 p-16 pl-42 pr-42">
          <mat-icon class="icon-sm cursor-pointer mr-8" svgIcon="close"></mat-icon>
          {{ 'BUTTONS.CANCEL' | transloco }}
        </button>
        <button (click)="updateService()" *ngIf="UpdateExtendService && !isDemoBlueprint"
                class="flex justify-items-center items-center mossgreen primary-fg p-16 pl-42 pr-42"
                type="button">
          {{ 'BUTTONS.CONTINUE' | transloco }}
          <mat-icon class="icon-sm ml-8" svgIcon="arrow_forward"></mat-icon>
        </button>
        <div class="button-container">
          <div *ngIf="sandboxLoader" class="spinner-container">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <button (click)="updateSandbox()" *ngIf="isDemoBlueprint"
                  [disabled]="selectedCapabilitiesArr.length === 0 || sandboxLoader"
                  [ngClass]="{'update-opacity': selectedCapabilitiesArr?.length === 0}"
                  class="flex justify-items-center items-center mossgreen primary-fg p-16 pl-18 pr-18"
                  type="button">
            {{ 'BLUEPRINT_SUMMARY.EXTEND.EXTEND_SANDBOX' | transloco }}
            <mat-icon class="icon-sm ml-8" svgIcon="arrow_forward"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
